import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import styled from 'styled-components';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { thesisTypes, thesisStatus } from '../../../utils/constants';

const ThesisItem = ({ data: thesis, index, onChange, onDelete }) => {
  return (
    <PublicationContainer key={index}>
      <SelectContainer variant='outlined' size='small' margin='normal'>
        <InputLabel id='type'>Tipo</InputLabel>
        <Select
          name='type'
          value={thesis.type}
          onChange={(e) => onChange(e, index, 'theses')}
          labelWidth={145}
        >
          <MenuItem value=''>
            <em>Seleccione una opción</em>
          </MenuItem>
          {thesisTypes.map((type) => (
            <MenuItem value={type.id} key={type.id}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </SelectContainer>
      <SelectContainer variant='outlined' size='small' margin='normal'>
        <InputLabel id='status'>Estado</InputLabel>
        <Select
          name='status'
          value={thesis.status}
          onChange={(e) => onChange(e, index, 'theses')}
          labelWidth={145}
        >
          <MenuItem value=''>
            <em>Seleccione una opción</em>
          </MenuItem>
          {thesisStatus.map((status) => (
            <MenuItem value={status.id} key={status.id}>
              {status.name}
            </MenuItem>
          ))}
        </Select>
      </SelectContainer>
      <InputText
        name={'name'}
        label={'Tema trabajo titulación'}
        margin='normal'
        value={thesis.name}
        size='small'
        variant='outlined'
        onChange={(e) => onChange(e, index, 'theses')}
        placeholder='Ingrese el tema del trabajo de titulación'
      />
      {index > 0 ? (
        <DeleteButton
          onClick={() => onDelete(index, 'theses')}
          color='primary'
        />
      ) : (
        <Space></Space>
      )}
    </PublicationContainer>
  );
};

const PublicationContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;
`;
const InputText = styled(TextField)`
  justify-self: flex-start;
  width: 70%;
  margin-right: 1em;
`;

const DeleteButton = styled(DeleteIcon)`
  cursor: pointer;
  width: 5%;
`;

const SelectContainer = styled(FormControl)`
  margin-right: 1em;
  width: 30%;
`;

const Space = styled.span`
  width: 6em;
`;

export default ThesisItem;
